/* eslint object-curly-newline: */
import { connect } from 'react-redux';
import LineChartComponent from './../Components/LineChartComponent.jsx';
import {
  metricsByJobIds,
  getReleaseMetricsJobsByBuildId,
  releaseMetricsPageReducer
} from './../reducers';
import { keys, mapValues, values } from 'lodash';
import { selectJob } from './../actions';
import {
  build,
  chart,
  jobNames,
  metrics as metricConstants,
  utils
} from './../helpers';

const actions = {
  'CASEOPENTIMING COMPLETE': 'rgba(73, 0, 146, 1)',
  'OPEN CASE COMPLETE': 'rgba(146, 0, 0, 1)',
  'SWITCH VIEW TO THUMBNAIL COMPLETE': 'rgba(0, 109, 219, 1)',
  'KEYWORDSEARCH FOR AND FILTER COMPLETE': 'rgba(0, 73, 73, 1)',
  'TAGS FILTER COMPLETE': 'rgba(146, 73, 0, 1)',
  'DATETIME FILTER COMPLETE': 'rgba(182, 109, 255, 1)',
  'DATETIME FILTER COMPLETE#2': 'rgba(109, 182, 255, 1)'
};

export const mapStateToProps = (state) => {
  const info = releaseMetricsPageReducer.getReleaseMetricsInfo(state);
  const jobsByVersions = getReleaseMetricsJobsByBuildId(state)({
    jobName: jobNames.PERFORMANCE,
    product: build.PRODUCTS.EXAMINE
  });
  const jobsByRelevantVersions = keys(jobsByVersions).reduce((result, version) => {
    const selectedVersion = info.sinceVersion || '0.0.0.0';
    if (utils.versionComparer(version, selectedVersion) > 0) {
      return {
        ...result,
        [version]: jobsByVersions[version]
      };
    }
    return result;
  }, {});

  const metricsByIds = metricsByJobIds(state);

  const metrics = mapValues(jobsByRelevantVersions, (performanceJobs) => {
    return performanceJobs.reduce((result, job) => {
      const metric = metricsByIds[job.id];
      return { ...result, ...metric };
    }, {});
  });

  const data = Object.keys(actions).map(action => {
    const caseAction = info.case.toUpperCase() + '|' + action;
    return values(metrics).map(m =>
      metricConstants.getPerformanceDuration(m, caseAction));
  });
  const pointRadius = metrics ? 0 : 4;

  return {
    data,
    series: Object.keys(actions).map(action => {
      return {
        backgroundColor: actions[action],
        borderColor: actions[action],
        label: action,
        pointRadius,
        borderWidth: 1
      };
    }),
    labels: keys(jobsByRelevantVersions),
    options: {
      scales: { xAxes: [{ offset: true }] },
      tooltips: {
        callbacks: {
          footer: (tooltipItem) => chart.metricsJobIdTooltipFooter(tooltipItem)(metrics)
        }
      }
    }
  };
};

export default connect(
  mapStateToProps,
  { onClick: selectJob }
)(LineChartComponent);


// WEBPACK FOOTER //
// src/Containers/ReleaseMetricsPerformanceChartContainer.jsx